var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.19922 8.29221L6.88559 9.98579L10.2653 6.59863",
    stroke: "#41C588",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.11921 1.30967C7.60202 0.896776 8.39273 0.896776 8.88254 1.30967L9.98813 2.26143C10.1981 2.44339 10.5899 2.59035 10.8698 2.59035H12.0594C12.8011 2.59035 13.4098 3.1992 13.4098 3.94101V5.13072C13.4098 5.40365 13.5568 5.80255 13.7387 6.0125L14.6904 7.11822C15.1032 7.6011 15.1032 8.3919 14.6904 8.88178L13.7387 9.9875C13.5568 10.1975 13.4098 10.5894 13.4098 10.8693V12.059C13.4098 12.8008 12.8011 13.4096 12.0594 13.4096H10.8698C10.5969 13.4096 10.1981 13.5566 9.98813 13.7386L8.88254 14.6903C8.39973 15.1032 7.60902 15.1032 7.11921 14.6903L6.01362 13.7386C5.8037 13.5566 5.41185 13.4096 5.13195 13.4096H3.9214C3.17968 13.4096 2.57091 12.8008 2.57091 12.059V10.8623C2.57091 10.5894 2.42397 10.1975 2.24903 9.9875L1.30439 8.87478C0.898538 8.3919 0.898538 7.6081 1.30439 7.12522L2.24903 6.0125C2.42397 5.80255 2.57091 5.41065 2.57091 5.13772V3.93402C2.57091 3.1922 3.17968 2.58335 3.9214 2.58335H5.13195C5.40485 2.58335 5.8037 2.43639 6.01362 2.25444L7.11921 1.30967Z",
    stroke: "#41C588",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSymbol);
export default __webpack_public_path__ + "static/media/VerifiedSymbol.2f9f9d062494cd1cbb961709d6c22b1c.svg";
export { ForwardRef as ReactComponent };